import React from 'react';
import UpdateActivated from './UpdateActivated';

var UpdateActivatedReload = function UpdateActivatedReload() {
  return React.createElement(UpdateActivated, null, function (isUpdateActivated) {
    if (isUpdateActivated) {
      window.location.reload(true);
    }

    return null;
  });
};

export default UpdateActivatedReload;